const styles = {
  container: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'row'
  }
}

export default styles
